function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _CustomElement() {
  return Reflect.construct(HTMLElement, [], this.__proto__.constructor);
}

;
Object.setPrototypeOf(_CustomElement.prototype, HTMLElement.prototype);
Object.setPrototypeOf(_CustomElement, HTMLElement);

/* icon/UI 24px/Link out (link, hyperlink).svg: width 24px x height 24px */
var DlsIconLinkOut =
/*#__PURE__*/
function (_CustomElement2) {
  _inherits(DlsIconLinkOut, _CustomElement2);

  function DlsIconLinkOut() {
    _classCallCheck(this, DlsIconLinkOut);

    return _possibleConstructorReturn(this, _getPrototypeOf(DlsIconLinkOut).apply(this, arguments));
  }

  _createClass(DlsIconLinkOut, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" fill=\"none\" display=\"block\" pointer-events=\"none\" viewBox=\"0 0 24 24\"><g fill=\"currentColor\" clip-path=\"url(#i4047554721__i4047554721__clip0_632:19)\"><path d=\"M12.023 18.695L8.74 21.449a5.143 5.143 0 01-6.612-7.879l5.253-4.408a5.143 5.143 0 017.245.634l-1.313 1.102a3.428 3.428 0 00-4.83-.422L3.23 14.883a3.429 3.429 0 004.408 5.253l3.283-2.755 1.102 1.314z\"/><path d=\"M21.872 10.43l-5.253 4.408a5.143 5.143 0 01-7.245-.634l1.313-1.102a3.429 3.429 0 004.83.423l5.253-4.408a3.429 3.429 0 00-4.408-5.253L13.08 6.62l-1.102-1.313L15.26 2.55a5.143 5.143 0 116.612 7.88z\"/></g><defs><clipPath id=\"i4047554721__i4047554721__clip0_632:19\"><path fill=\"currentColor\" d=\"M0 0h24v24H0z\"/></clipPath></defs></svg>";
    }
  }], [{
    key: "define",
    value: function define() {
      var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dls-icon-link-out';

      try {
        window.customElements.define(tagName, this);
      } catch (e) {
        /* console.error(e); */
      }
    }
  }]);

  return DlsIconLinkOut;
}(_CustomElement);

export { DlsIconLinkOut as default };
DlsIconLinkOut.define();